module.exports = __webpack_public_path__ + "img/editor.4ed19867.svg";